import apiClient from './apiClient';

export const bundleApi = {
  /** Lista los ficheros del bucket itr_bundle con sus metadatos. */
  list: () => apiClient.get('/bundle/list/'),

  /**
   * Solicita una URL firmada temporal para descargar un blob concreto.
   * @param {string} blobName - Ruta relativa del blob dentro del bucket.
   */
  signedUrl: (blobName) =>
    apiClient.get('/bundle/signed-url/', { params: { blob: blobName } }),
};
